// macadamia-app/src/macadamia-core/components/A4PageWrapper.tsx
import React from 'react';

interface A4PageWrapperProps {
  children: React.ReactNode;
  isEditing: boolean;
}

const A4PageWrapper: React.FC<A4PageWrapperProps> = ({ children, isEditing }) => {

  const pageStyle: React.CSSProperties = {
    padding: '56px',
    borderRadius: '1px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.02)',
    width: '100%',
    maxWidth: '794px',
    margin: '0 auto 20px auto',
    position: 'relative',
    minHeight: '1122px',
  };

  const containerStyle: React.CSSProperties = {
    width: '100%',
    padding: '20px',
    minHeight: '100vh',
  };

  const containerClass = `a4-pages-container ${isEditing ? 'editing-mode' : 'reading-mode'}`;

  return (
    <div style={containerStyle} className={containerClass}>
      <div
        className="a4-page"
        style={pageStyle}
        data-spatial-element="page"
        data-page-index="0"
      >
        {children}
      </div>

      <style>{`
        /* Mode clair */
        .a4-pages-container {
          background-color: #f5f5f5;
        }

        .a4-page {
          background: white;
          border: 0.5px solid #e0e0e0;
        }

        /* Mode sombre */
        .dark .a4-pages-container {
          background-color: #101214;
        }

        .dark .a4-page {
          background: #1d2125;
          border: 0.5px solid #2a2f35;
          box-shadow: 0 2px 10px rgba(0,0,0,0.3);
        }

        /* Responsive : Sur mobile (< 768px), désactiver les contraintes A4 */
        @media (max-width: 768px) {
          .a4-pages-container {
            padding: 12px !important;
            min-height: auto !important;
          }

          .a4-page {
            max-width: none !important;
            min-height: auto !important;
            padding: 24px !important;
            margin: 0 !important;
            box-shadow: none !important;
            border: none !important;
          }
        }

        @media print {
          .a4-pages-container {
            background: white !important;
            padding: 0 !important;
          }

          .a4-page {
            background: white !important;
            margin: 0 !important;
            box-shadow: none !important;
            border: none !important;
            min-height: auto !important;
          }
        }

        @page {
          size: A4;
          margin: 0;
        }
      `}</style>
    </div>
  );
};

export default A4PageWrapper;